<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-hxSalesPlatform',
  components: {
    PageTable,
  },
}
</script>